import React from 'react';

function SupplierAgreementField({ value }) {
  if (value === null || value === undefined) return <>-</>;

  if (value === true) {
    return <>Esterno</>;
  } else if (value === false) {
    return <>Interno</>;
  }

  return <>-</>;
}

export default SupplierAgreementField;
